import React from "react";
import Alert from "../../features/product-swap/alert/Alert";

const NotificationBar = ({ notification, closeCallback}) => {
    const {severity, message} = notification;
    return (
        <div className="mt-25 ml-1 mr-1">
            <Alert severity={severity} onClose={() => closeCallback()}>
                {message}
            </Alert>
        </div>
    );
};

export default NotificationBar;
